"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_infographic__or__pie__chart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "025ec44e-6f11-4aa9-ad98-e03e7de9f74b",
    "data-name": "infographics-hi",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.5 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "infographic-hi"), /*#__PURE__*/React.createElement("g", {
    id: "3d676e6c-72a1-4a8b-81e3-3713acdd18d4",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b1b6dd7-2b42-43e9-993a-5a938ffec564",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a41142bd-1a3b-45da-98f6-4eb7cef292d2",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9b32620d-7222-4359-8359-96175edf270d",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5af3e8c3-019a-43a4-a4e6-0162e4048cb7",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "43d00a7d-8569-464c-b544-20d0c0fa830f",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92cc0344-de0c-4bce-a277-1f39ee8543dc",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14ef46ed-0fb8-44f9-b68e-7313b6e7307c",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6ac17fd0-8e11-4dfd-9a87-ba981c6c554e",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "832bc9f6-d5d0-4f1c-9ef6-79604ff317d0",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b1d200ba-6efc-40bd-8b8e-bb66dccc6b98",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c37381c4-53a7-4bdc-8f7b-6e5b81d9f723",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5db1affa-215d-4f77-b7b8-31f943e9bd4b",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0b1bddfd-aa6c-423e-a9fb-92c3e7071a3d",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ffa15b7f-c9eb-455d-a055-1fcdcb9b6b02",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l71.24,36.28a79.88,79.88,0,0,1-14.7,20.23L96,96.09",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l56.54,56.5a79.88,79.88,0,0,0,14.7-20.23L96,96.09",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l79.36-9.74a76,76,0,0,1-8.12,46Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09,116.65,18.9c32.46,8.69,54.57,34.11,58.67,67.45Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l56.54,56.51a79.93,79.93,0,0,1-113.08-113C60.22,18.8,88.25,11.29,116.65,18.9Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.12a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.12Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }))))))))))))))));
}

var _default = ic_infographic__or__pie__chart;
exports.default = _default;